export const enum ToolsSecondaryMenuItems {
  ARCHI_APPS = 'archi-apps',
  ARCHEIDOS = 'archeidos',
  MODEL_VIEWER = 'model-viewer'
}
